import {
  ShowNotificationFunction,
  ShowNotificationFunctionProps,
} from '@dixa/lib-integrations-partner-widgets';
import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { useCallback } from 'react';

import { notificationActions } from 'components/notifications/actions/notification';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { partnerIntegrationNotificationTimeout } from '../partnerIntegrationsWidget.utils';

type UsePartnerIntegrationNotificationResult = ShowNotificationFunction;

/**
 * Hook to serve a callback function that can be used within the partner
 * integration widget to trigger agent-interface notifications.
 */
export function usePartnerIntegrationNotification(): UsePartnerIntegrationNotificationResult {
  const dispatch = useAppDispatch();

  return useCallback(
    ({ title, text, icon, severity }: ShowNotificationFunctionProps) => {
      const time =
        severity === 'warning' || severity === 'danger'
          ? 0
          : partnerIntegrationNotificationTimeout;
      const className = severity as string;

      const payload: NotificationPayloadT = {
        title,
        text,
        icon,
        className,
        time,
      };
      dispatch(notificationActions.notificationAdd(payload));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
